<template>
    <el-dialog :visible.sync="visible" width="400px" :close-on-click-modal="false" :show-close="false" destroy-on-close>
        <template v-slot:title>
            <div class="dialog_title">
                <div class="title">知识点小测验</div>
                <div class="timers">剩余答题时间：<span style="color: red;">{{ remainingTime }}s</span></div>
            </div>
        </template>
        <div v-if="question && question.questionContent" style="font-size: 15px;">{{ type() + question.questionContent.questionStem }}</div>
        <!--带图片的题，则展示图片-->
        <div v-if="question && question.questionContent && question.questionContent.imageUrlList" style="margin-top:5px;">
            <el-image v-for="(imgUrl,index) in question.questionContent.imageUrlList" :key="index" @click="picturePreview(imgUrl)"
                      style="width: 100px; height: 100px" :src="imgUrl" fit="cover" />

        </div>
        <div class="choicess">
            <div :class="{ 'item': true, 'active': item.checked }" v-for="(item, index) in choices" :key="index"
                @click="updateChecked(index)">
                <span>{{ item.content }}</span>
                <img v-if="item.checked" style="width: 18px;height: 18px;" src="@/assets/images/correct.png" alt="">
                <div v-else style="min-width:18px;min-height: 18px;"></div>
            </div>
        </div>
        <el-button type="primary" :class="{ 'submit-btn': true, 'active': btnDisabled }" @click="submit">提交</el-button>

    </el-dialog>
</template>
<script>
// SingleChoice MultipleChoice TrueOrFalse
export default {
    name: 'knowledgeDialog',
    props: ['show', 'knowledgeId', 'playSecondsAt', 'courseId'],
    watch: {
        show(val) {
            if (val) {
                this.init()
            } else {
                this.visible = false
            }
        }
    },

    data() {
        return {
            randomKnowledgeId: null,
            visible: false,
            knowledge: {},
            question: null,
            choices: [],
            rightAnswer: null,
            btnDisabled: true,
            remainingTime: 60,
            interval: null,
        }
    },
    methods: {
        picturePreview (imgUrl) {  // 查看大图
            this.$emit('handleChildEvent', imgUrl)
        },
        startCountdown() {
            this.interval = setInterval(() => {
                this.remainingTime -= 1;
                if (this.remainingTime <= 0) {
                    clearInterval(this.interval);
                    this.$emit('result', false)
                    this.visible = false
                }
            }, 1000);
        },
        submit() {
            clearInterval(this.interval);
            let answer
            if (this.question.questionType == 'TrueOrFalse' || this.question.questionType == 'SingleChoice') {
                this.choices.forEach(item => {
                    if (item.checked) {
                        answer = item.value
                    }
                })
            } else if (this.question.questionType == 'MultipleChoice') {
                answer = this.choices.filter(item => item.checked)
                    .map(item => item.value)
                    .join(',');
            }
            if (answer == this.rightAnswer) {
                this.$http.post(API_ROOT.college + "/course/submitKnowledgeXlk", { knowledgeId: this.randomKnowledgeId, courseId: this.courseId, assitant: 'Yes' }).then((res) => { })
                this.$emit('result', true)
            } else {
                this.$emit('result', false)
            }
            this.visible = false
        },
        type() {
            if (this.question.questionType == 'TrueOrFalse') {
                return '【判断题】'
            } else if (this.question.questionType == 'SingleChoice') {
                return '【单选题】'
            } else if (this.question.questionType == 'MultipleChoice') {
                return '【多选题】'
            }
        },
        updateChecked(index) {
            if (this.question.questionType == 'TrueOrFalse' || this.question.questionType == 'SingleChoice') {
                this.choices.map(item => {
                    item.checked = false
                })
            }
            this.choices[index].checked = !this.choices[index].checked
            this.btnDisabled = true
            this.choices.forEach(item => {
                if (item.checked) {
                    this.btnDisabled = false
                }
            })
        },
        init() {
            this.remainingTime = 60
            this.visible = true
            this.$http.post(API_ROOT.college + "/course/getQuesKnowledgeXlk", { knowledgeId: this.knowledgeId, playSecondsAt: this.playSecondsAt }).then((res) => {
                var result = res.data;
                if (result.success) {
                    this.knowledge = result.data;
                    this.randomKnowledgeId = this.knowledge.knowledgeId;
                    this.question = result.data.question
                    if (this.question.questionType == 'TrueOrFalse') {
                        this.choices = [
                            {
                                value: true,
                                content: '正确',
                                checked: false,
                            },
                            {
                                value: false,
                                content: '错误',
                                checked: false,
                            }
                        ]
                        this.rightAnswer = this.question.questionContent.rightAnswer
                    } else if (this.question.questionType == 'SingleChoice' || this.question.questionType == 'MultipleChoice') {
                        this.choices = Object.keys(this.question.questionContent.choices).map(key => {
                            return {
                                value: key,
                                content: key + '：' + this.question.questionContent.choices[key],
                                checked: false
                            };
                        });
                        if (this.question.questionType == 'SingleChoice') {
                            this.rightAnswer = this.question.questionContent.rightAnswer
                        } else if (this.question.questionType == 'MultipleChoice') {
                            this.rightAnswer = this.question.questionContent.rightAnswer.join(',')
                        }
                    }
                    this.startCountdown()
                } else {
                    this.$alert(result.msg);
                }
            })
        }
    },
}
</script>

<style lang="less" scoped>
.dialog_title {
    width: 100%;
    display: flex;
    flex-direction:row;
    align-items: center;
    justify-content: space-between;

    .title {
        font-size: 15px;
        font-weight: 500;
        color: black
    }
    .timers {
        font-size: 15px;
    }
}

.choicess {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    .item {
        width: 90%;
        padding: 8px 15px;
        text-align: left;
        border-radius: 5px;
        border: 1px solid #ccc;
        margin-top: 15px;
        color: darkgray;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        &.active {
            border: 1px solid #497AF2;
        }
    }
}

.submit-btn {
    width: 140px;
    height: 40px;
    margin-left: 110px;
    margin-top: 30px;
    border-radius: 20px;

    &.active {
        background-color: lightgray !important;
        border: none !important;
    }
}
</style>


// WEBPACK FOOTER //
// ./src/page/train/videoDetail/knowledgeDialog.vue